<section [hidden]="!processing">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading content">
  </mat-progress-bar>
</section>

<section [hidden]="partner == null || processing">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <h2 mat-dialog-title>
      <mat-icon class="icon-20" *ngIf="partner.id > 0">edit</mat-icon>
      <mat-icon class="icon-20" *ngIf="partner.id === 0">add</mat-icon>
      <span *ngIf="partner.id > 0">Edit</span>
      <span *ngIf="partner.id === 0">Add</span> Partner
    </h2>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button mat-raised-button (click)="savePartner()" [disabled]="processing || partner == null" color="primary">
        Save Partner
      </button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel" title="Cancel">
        Cancel
      </button>
    </div>
  </div>

  <mat-dialog-content>
    <div fxLayout="row wrap" class="matero-row">
      <mat-card [ngClass]="{'bg-gray-700': sharedService.darkMode,'bg-indigo-50': !sharedService.darkMode}" fxFlex="100">
        <form #form="ngForm" [formGroup]="editForm" fxFlex="100" fxFlex.lt-md="100">
          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-checkbox formControlName="active"> Active </mat-checkbox>
            </div>
            <div fxFlex="66.6" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" [style.width.%]="95">
                <mat-label>Access Type</mat-label>
                <mat-select id="accessType" name="accessType" formControlName="accessType" required>
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of partnerService.accessTypes" value="{{item}}">{{item}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="33.3" fxFlex.lt-sm="100">

            </div>
            <div fxFlex="66.6" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" [style.width.%]="95">
                <mat-label>Organization</mat-label>
                <input type="text" placeholder="Search Organizations" id="labId" name="labId" aria-label="Organization" matInput [formControl]="organizationsControl" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let item of filteredOrganizations | async" [value]="item.displayName" (onSelectionChange)="onOrganizationSelected(item.id)">
                    {{item.displayName}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field [style.width.%]="95">
                <input formControlName="partnerName" placeholder="Partner Name" matInput required />&nbsp;&nbsp;
              </mat-form-field>
            </div>
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field [style.width.%]="95">
                <input formControlName="partnerEmail" placeholder="Partner email" matInput />&nbsp;&nbsp;
              </mat-form-field>
            </div>
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field [style.width.%]="95">
                <input formControlName="partnerPhone" placeholder="Partner Phone" matInput />&nbsp;&nbsp;
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field [style.width.%]="95">
                <input formControlName="partnerAddress" placeholder="Partner Address" matInput />&nbsp;&nbsp;
              </mat-form-field>
            </div>
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" [style.width.%]="95">
                <mat-label>Access Start Date</mat-label>
                <input id="accessStartDate" name="accessStartDate" formControlName="accessStartDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickeaccessStartDate" />
                <mat-datepicker-toggle matSuffix [for]="datepickeaccessStartDate"></mat-datepicker-toggle>
                <mat-datepicker #datepickeaccessStartDate>
                  <mat-datepicker-actions>
                    <button mat-raised-button color="primary" matDatepickerApply>
                      Apply
                    </button>
                    <button mat-button matDatepickerCancel>Cancel</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" [style.width.%]="95">
                <mat-label>Access End Date</mat-label>
                <input id="accessEndDate" name="accessEndDate" formControlName="accessEndDate" placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickeraccessEndDate" />
                <mat-datepicker-toggle matSuffix [for]="datepickeraccessEndDate"></mat-datepicker-toggle>
                <mat-datepicker #datepickeraccessEndDate>
                  <mat-datepicker-actions>
                    <button mat-raised-button color="primary" matDatepickerApply>
                      Apply
                    </button>
                    <button mat-button matDatepickerCancel>Cancel</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="33.3" fxFlex.lt-sm="100">
              <mat-checkbox formControlName="requiresDisclaimerApproval" (click)="clickRequiresDisclaimerApproval()">
                Disclaimer Approval Required
              </mat-checkbox>
            </div>
            <div fxFlex="66.6" fxFlex.lt-sm="100">
              <mat-form-field [style.width.%]="95">
                <textarea formControlName="disclaimer" placeholder="Disclaimer" matInput></textarea>
              </mat-form-field>
            </div>
          </div>
          <br />
          <div fxLayout="row wrap" class="matero-row">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <mat-checkbox formControlName="requiresPassKey" (click)="clickRequiresPassKey()">
                Pass Key Required
              </mat-checkbox>
            </div>
          </div>

        </form>
      </mat-card>
    </div>
    <br>
    <div fxLayout="row wrap" class="matero-row" *ngIf="partner.requiresPassKey">
      <mat-card [ngClass]="{'bg-gray-700': sharedService.darkMode,'bg-indigo-50': !sharedService.darkMode}" fxFlex="100">
        <div fxLayout="row wrap" class="matero-row">
          <div fxFlex="100" fxFlex.lt-sm="100">
            <span><strong>Pass Keys ({{passKeys.length}}) </strong></span>
            <br /><br />
            <div *ngFor="let item of passKeys; let i = index;" class="rowPassKeys">
              <div fxFlex="100" fxFlex.lt-sm="100" fxLayout="row wrap" class="rowPassKeys">
                <div fxFlex="15" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  <mat-label *ngIf="i == 0">Key</mat-label>
                  <span style="margin-top: 18px;">{{item.passKey}}</span>
                </div>
                <div fxFlex="70" fxFlex.lt-sm="100" fxLayout="column" fxLayoutAlign="start">
                  <mat-label *ngIf="i == 0">Name</mat-label>
                  <mat-form-field>
                    <input matInput id="comments{{i}}" name="comments{{i}}" [(ngModel)]="item.comments" type="text" />
                  </mat-form-field>
                </div>
                <div fxFlex="15" fxFlex.lt-sm="100" fxLayoutAlign="start">
                  <br>
                  <span style="margin-top: 12px;">
                    <a href="javascript:void(0)" (click)="clipboardCopyPassKey(item.passKey)" title="Clipboard Copy Pass Key: {{item.passKey}}">
                      <mat-icon>content_copy</mat-icon>
                    </a>
                    &nbsp;
                    <a href="javascript:void(0)" (click)="removePassKey(i)" title="Remove Pass Key {{item.passKey}}">
                      <mat-icon>delete</mat-icon>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <br /><br />
            <button mat-raised-button (click)="addPassKey()" [disabled]="processing || partner == null">
              Add Pass Key
            </button>
          </div>
        </div>
      </mat-card>
    </div>
  </mat-dialog-content>
</section>